import { videoFavoriteState, videoLikedState } from 'constant/video'
import CoverImage from '../CoverImage'
import InfoWrapper from '../InfoWrapper'
import Toolbar from '../Toolbar'
import { StyledVirtualPage } from './Styled'
import { useSelector } from 'react-redux'
import { selectTopicList } from 'redux/selector/app'
import ToolbarHome from '../ToolbarHome'
import { StyledHomeUploaderInfo, StyledUploaderInfo } from '../PlayerPage/Styled'
import { SchemaShortVideoShow } from 'api'

interface PlaceHolderPageProps {
  videoInfo: any
  onBase64ImageLoad?: any
  posterSrc?: string | null | false
  toolbarStyle?: 'default' | 'home'
  onLike?: () => void
  onSave?: () => void
  onShare?: (video: SchemaShortVideoShow) => void
}

const PlaceHolderPage = ({
  videoInfo,
  onBase64ImageLoad,
  posterSrc = null,
  toolbarStyle,
  onLike,
  onSave,
  onShare,
}: PlaceHolderPageProps) => {
  const topicList = useSelector(selectTopicList)

  let topics: any[] = []

  if (videoInfo) {
    topics =
      videoInfo.topic_ids
        ?.map((id: any) => {
          const topicItem = topicList.find((t: any) => t.id === id)
          if (topicItem) {
            return {
              text: '#' + topicItem.name,
              params: {
                topic_ids: String(topicItem.id),
              },
            }
          } else {
            return null
          }
        })
        .filter((text: any) => text != null) ?? []
  }
  return (
    <StyledVirtualPage>
      <InfoWrapper>
        <CoverImage
          objectFit={toolbarStyle === 'home' ? 'auto' : 'contain'}
          src={posterSrc as string | null}
          onBase64ImageLoad={onBase64ImageLoad}
          base64SrcSource={videoInfo.coverphoto_v}
          style={{ background: 'black' }}
        />
        {toolbarStyle === 'default' ? (
          <StyledUploaderInfo
            topics={topics}
            uploader={'@' + videoInfo.uploader_name}
            uploaderId={videoInfo.uploader_id}
            videoName={videoInfo.title}
          />
        ) : (
          <StyledHomeUploaderInfo
            topics={topics}
            uploader={'@' + videoInfo.uploader_name}
            uploaderId={videoInfo.uploader_id}
            videoName={videoInfo.title}
          />
        )}{' '}
      </InfoWrapper>
      {toolbarStyle === 'default' ? (
        <Toolbar
          key={videoInfo.id}
          liked={videoInfo.like === videoLikedState.TRUE}
          saved={videoInfo.favorite === videoFavoriteState.TRUE}
          likeCount={videoInfo.like_count}
          saveCount={videoInfo.favorite_count}
          onLike={onLike}
          onSave={onSave}
        ></Toolbar>
      ) : (
        <ToolbarHome
          key={videoInfo.id}
          liked={videoInfo.like === videoLikedState.TRUE}
          saved={videoInfo.favorite === videoFavoriteState.TRUE}
          likeCount={videoInfo.like_count}
          saveCount={videoInfo.favorite_count}
          onLike={onLike}
          onSave={onSave}
          onShare={() => onShare?.(videoInfo)}
          uploaderId={videoInfo.uploader_id}
          uploaderIcon={videoInfo.uploader_icon}
        ></ToolbarHome>
      )}
    </StyledVirtualPage>
  )
}

export default PlaceHolderPage
